import { useState } from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";

import theme from "../../../styles/theme";
import noneDriver from "../../../assets/none_driver.png";
import plural from "../../../utils/helpers/plural";

// Champion photos come back as bare asset paths (`drivers/Foo.png`) that only resolve once the
// backend prepends the CloudFront domain — which the mock cannot do. Everything falls back to the
// placeholder, and the fallback is latched so a broken placeholder cannot loop.
export function ChampionPhoto({ src, alt, className }) {
  const [failed, setFailed] = useState(false);

  return (
    <img
      className={className}
      src={failed || !src ? noneDriver : src}
      alt={alt}
      onError={() => setFailed(true)}
    />
  );
}

// The championship badge, shared by every variant — the squared race-cell treatment the season
// standings table uses, tinted with the team the title was won with. No year: the season short
// names already carry it ("Open Wheel League 25").
export const TitleChipWrap = styled.div`
  height: 28px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 12px;
  border-radius: 2px;
  background: #3a3a3a;
  border-left: 3px solid ${({ $color }) => $color || theme.colors.grey};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

export function TitleChip({ title }) {
  return (
    <Tooltip title={title.seasonName} arrow placement="top">
      <TitleChipWrap $color={title.team?.color}>{title.seasonShortName}</TitleChipWrap>
    </Tooltip>
  );
}

const TooltipList = styled.span`
  color: ${theme.colors.white};
`;

// Overflow badge — collapses the titles that did not fit, listing them on hover.
const MoreChipWrap = styled(TitleChipWrap)`
  border-left-color: ${theme.colors.gold};
  color: ${theme.colors.gold};
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 700;
`;

export function MoreChip({ titles }) {
  return (
    <Tooltip
      title={<TooltipList>{titles.map((t) => t.seasonName).join(", ")}</TooltipList>}
      arrow
      placement="top"
    >
      <MoreChipWrap>+{titles.length}</MoreChipWrap>
    </Tooltip>
  );
}

export function titleWord(count) {
  return plural(count, ["титул", "титули", "титулів"]);
}
